import { configureStore } from "@reduxjs/toolkit";
import stepSlice from "../StepsContext";


const store = configureStore({
    reducer: {"stepSlice": stepSlice.reducer}
});


export default store;